export default "__VITE_ASSET__rBb4YzOZ__"